module.exports = __webpack_public_path__ + "static/media/SF-1.6f94162f.mp3";